import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-migrations-list',
  templateUrl: './migrations-list.component.html',
  styleUrls: ['./migrations-list.component.scss'],
})
export class MigrationsListComponent extends BaseListCtl {
  //Contains application id of usecases
  public applicationId: number = 0;
  public searchMigration: any;
  public schema: any;
  public changeLog: any;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    locator.config
      .getProperty('endpoint.migrations')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
    let _self = this;
    _self.is_prelaod = false;
    _self.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    _self.form.searchParams['applicationId'] = _self.applicationId;
    _self.form.searchParams['orderBy'] = 'name';
    _self.getApplicationDetails(_self.applicationId);
  }

  /**
   * Get usecase and its attributes
   * @param id
   */
  public createMigration() {
    let _self = this;
    let url =
      _self.locator.config.get('endpoint.migrations') +
      '/create/' +
      _self.applicationId;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form['error'] = !res.success;
      _self.form['message'] = res.message;
      if (res.result?.inputerror?.key) {
        _self.form['message'] = res.result['inputerror']['key'];
      } else {
        _self.form['inputerror'] = res.result['inputerror'];
      }

      if (res.success) {
        //_self.applicationForm['data'] = res.result['data'];

        console.log(res.result['data']);
        _self.search();
      }
    });
  }

  override preload(): void {}

  /**
   * Contains attribute data
   */
  public applicationForm: any = {
    error: false, //error
    message: null, //error or success message
    preload: null, // preload data
    inputerror: {}, // form input error messages
    data: {},
  };

  /**
   * Get Application details
   */
  getApplicationDetails(id: any) {
    let _self = this;
    //localhost:8085/ctl/application/get/10087390
    let url = _self.locator.config.get('endpoint.application') + '/get/' + id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationForm['error'] = !res.success;
      _self.applicationForm['message'] = res.message;
      _self.applicationForm['inputerror'] = res.result['inputerror'];

      if (res.success) {
        _self.applicationForm['data'] = res.result['data'];
      }
    });
  }

  setSchema(e: any) {
    this.schema = e.schema;
    this.changeLog = e.changeLog;
  }

  compareToValue: any | null = null;
  compareObject: any = null;

  onSelectChange() {
    console.log(this.compareToValue);
    // Find the selected object from the list
    this.compareObject = this.form.list.find(
      (e: any) => e.id == this.compareToValue
    );
    console.log(this.compareObject); // Logs the selected object
  }

  applyRollback(e: any): void {}

  applyMigration(e: any): void {
    let _self = this;
    let url =
      _self.locator.config.get('endpoint.migrations') + '/apply/' + e.id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form['error'] = !res.success;
      _self.form['message'] = res.message;

      if (res.success) {
        //_self.applicationForm['data'] = res.result['data'];

        console.log(res.result['data']);
        _self.search();
      }
    });
  }
}
